import { EventActionBar } from '@vimeo/clip-ui/components/EventActionBar';

import { useEventActionBarModule } from '../hooks/use-event-action-bar-module';

export const EventActionBarModule = ({
  isInteractionToolsEnabled,
}: {
  isInteractionToolsEnabled?: boolean;
}) => {
  const { actionBarDisplayConfig, actionBarHandlers, shouldShowActionBar } =
    useEventActionBarModule({ isInteractionToolsEnabled });

  if (!shouldShowActionBar) {
    return null;
  }

  return <EventActionBar {...actionBarHandlers} {...actionBarDisplayConfig} />;
};
